// extracted by mini-css-extract-plugin
export default {"peliculas":"Inicio_peliculas__u6g7n","grid_peliculas":"Inicio_grid_peliculas__IZ39e","slider":"Inicio_slider__VgHDE","linea":"Inicio_linea__mZIM9"};